<script setup>
import { useRouter } from 'vue-router';

  defineProps({
    title: {
      type: String,
      required: false,
    },
    useBack: {
      type: Boolean,
      default: false,
    },
    routeList: {
      type: Array,
      required: false,
      default: () => [],
    },
  });

  const router = useRouter();
</script>

<template>
  <header class="app-header">
    <Button v-if="useBack" text class="icon -ml-8" aria-label="뒤로가기" @click="router.back()">
      <i class="pi pi-chevron-left"></i>
    </Button>
    <div class="header-info-wrap">
      <div v-if="$slots.title" class="header-title-wrap">
        <slot name="title"></slot>
      </div>
      <h2 v-else class="header-title" :class="{'is-route' : routeList?.length}">{{ title }}</h2>
      <Breadcrumb v-if="routeList" class="header-breadcrumb" :model="routeList">
        <template #item="{ item, props }">
          <span v-if="!item.route" v-bind="props.action" class="no-click">
            <span class="text-color">{{ item.label }}</span>
          </span>
          <router-link v-else v-slot="{ href, navigate }" :to="item.route" custom>
            <a :href="href" v-bind="props.action" @click="navigate">
              <span :class="[item.icon, 'text-color']" />
              <span class="text-primary font-semibold">{{ item.label }}</span>
            </a>
          </router-link>
        </template>
      </Breadcrumb>
    </div>
    <div v-if="$slots.actionLeft" class="header-actions">
      <slot name="actionLeft"></slot>
    </div>
    <div class="spacer"></div>
    <div v-if="$slots.action" class="header-actions">
      <slot name="action">
        
      </slot>
    </div>
  </header>
</template>